module.exports = __webpack_public_path__ + "static/roompal-31047a15d06532fbb3225d0d5e4a8e2d.png";